import { render, staticRenderFns } from "./SplcPzym.vue?vue&type=template&id=2bdf271e&scoped=true&"
import script from "./SplcPzym.vue?vue&type=script&lang=js&"
export * from "./SplcPzym.vue?vue&type=script&lang=js&"
import style0 from "./SplcPzym.vue?vue&type=style&index=0&id=2bdf271e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf271e",
  null
  
)

export default component.exports